import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Reveal, Eyebrow } from "@/components/Reveal";
import OpportunityCard from "@/components/OpportunityCard";
import { CATEGORIES } from "@/data/constants";

export default function Opportunities() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const active = params.get("category") || "All";

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data.map((c) => c.name))).catch(() => setCats(CATEGORIES));
  }, []);

  useEffect(() => {
    setLoading(true);
    const cat = active === "All" ? undefined : active;
    api.get("/opportunities", { params: cat ? { category: cat } : {} })
      .then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, [active]);

  const setCat = (c) => { if (c === "All") setParams({}); else setParams({ category: c }); };

  return (
    <div data-testid="opportunities-page" className="min-h-screen bg-obsidian px-6 pt-32 pb-24 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow>Opportunities</Eyebrow>
          <h1 className="mt-5 font-serif text-4xl leading-tight text-warmwhite lg:text-6xl">Curated Opportunities</h1>
          <p className="mt-5 max-w-xl font-sans text-base text-softgrey">
            Each opportunity shows only information appropriate before confidential disclosure.
          </p>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-3">
          {["All", ...cats].map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                    className={`border px-5 py-2 font-sans text-xs tracking-wide transition-colors ${
                      active === c ? "border-gold bg-gold text-obsidian" : "border-gold/25 text-softgrey hover:border-gold/60 hover:text-warmwhite"
                    }`}>
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="mt-20 text-center font-serif text-gold">Loading…</div>
        ) : items.length === 0 ? (
          <div className="mt-20 border border-gold/15 bg-seablue/15 p-16 text-center">
            <p className="font-serif text-2xl text-warmwhite">No opportunities in this category yet.</p>
            <p className="mt-3 font-sans text-sm text-softgrey">Tell us what you're looking for and we'll source it.</p>
          </div>
        ) : (
          <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {items.map((opp, i) => (
              <Reveal key={opp.id} delay={i * 0.05}><OpportunityCard opp={opp} /></Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
